"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex flex-col items-center gap-5 p-5" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-col gap-5 w-full uppercase"
};
const _hoisted_3 = { class: "self-center font-bold" };
const _hoisted_4 = { class: "flex flex-col gap-2" };
const _hoisted_5 = { class: "font-bold" };
const _hoisted_6 = { class: "flex flex-col gap-2" };
const _hoisted_7 = { class: "flex gap-2 items-center" };
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "self-start text-xl font-bold" }, " – ", -1);
const _hoisted_9 = { class: "icon marso-icon-info-circle text-blue tooltip" };
const _hoisted_10 = { class: "tooltip-content uppercase !p-2" };
const _hoisted_11 = { class: "flex gap-2 items-center" };
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "self-start text-xl font-bold" }, " – ", -1);
const _hoisted_13 = { class: "icon marso-icon-info-circle text-blue tooltip" };
const _hoisted_14 = { class: "tooltip-content uppercase !p-2" };
const _hoisted_15 = { class: "flex gap-2 items-center" };
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "self-start text-xl font-bold" }, " – ", -1);
const _hoisted_17 = { class: "icon marso-icon-info-circle text-blue tooltip" };
const _hoisted_18 = { class: "tooltip-content uppercase !p-2" };
const _hoisted_19 = {
    key: 1,
    class: "uppercase font-bold"
};
const _hoisted_20 = {
    key: 2,
    class: "flex flex-col w-full"
};
const _hoisted_21 = { class: "flex flex-col md:flex-row md:justify-between items-center p-2 pr-4 pl-4 cursor-pointer" };
const _hoisted_22 = { class: "flex flex-col md:flex-row gap-2 items-center" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
    key: 0,
    class: "marso-icon-chevron-up text-xl"
};
const _hoisted_27 = {
    key: 1,
    class: "marso-icon-chevron-down text-xl"
};
const _hoisted_28 = {
    key: 0,
    class: "hidden md:flex md:items-center bg-gray-dark p-2 pr-4 pl-4 text-white uppercase font-bold"
};
const _hoisted_29 = { class: "flex-1" };
const _hoisted_30 = { class: "flex-1" };
const _hoisted_31 = { class: "flex-1" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_34 = { key: 1 };
const _hoisted_35 = { class: "flex flex-col md:hidden bg-gray-dark text-white uppercase font-bold p-2 pr-4 pl-4" };
const _hoisted_36 = { class: "flex-1" };
const _hoisted_37 = { class: "flex-1" };
const _hoisted_38 = { class: "flex-1" };
const _hoisted_39 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex-1" }, null, -1);
const _hoisted_40 = { class: "flex flex-col md:flex-row items-center w-full p-2 pr-4 pl-4" };
const _hoisted_41 = { class: "flex-1" };
const _hoisted_42 = { class: "flex-1" };
const _hoisted_43 = { class: "flex-1" };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_46 = { class: "flex justify-center w-full flex-col md:flex-row gap-5" };
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const i18n_1 = require("../../common/i18n");
const PricingEnum_1 = require("../../stores/pricing/PricingEnum");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PricingConflictModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        conflictSaveButtonIsActive: {
            type: Boolean,
            required: true
        },
        pricingConflicts: {
            type: Array,
            required: true,
        },
        groupedConflicts: {
            type: Array,
            required: true,
        },
        expandedConflictRow: {
            type: [Number, null],
            required: true
        },
        currentUser: {
            type: Object,
            required: true
        }
    },
    emits: [
        "update:is-open",
        "update:expanded-conflict-row",
        "delete-conflicted-pricing-filter",
        "delete-conflicted-pricing-filters",
        "save-and-deactivate-pricing",
        "activate-pricing"
    ],
    setup(__props, { emit }) {
        const props = __props;
        const close = () => {
            emit("update:is-open", false);
        };
        const expandConflictRowToggle = (id) => {
            emit("update:expanded-conflict-row", props.expandedConflictRow === id ? null : id);
        };
        const deleteConflictedPricingFilter = (id) => {
            emit("delete-conflicted-pricing-filter", id);
        };
        const deleteConflictedPricingFilters = (id) => {
            emit("delete-conflicted-pricing-filters", id);
        };
        const saveAndDeactivatePricing = () => {
            emit("save-and-deactivate-pricing");
        };
        const activatePricing = () => {
            emit("activate-pricing");
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                "width-classes": "lg:w-1/2",
                title: (0, vue_2.unref)(i18n_1.trans)('conflicts_found', 'Conflicts found', 'pricing_conflict_modal'),
                "is-open": __props.isOpen,
                onClose: close
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (!__props.conflictSaveButtonIsActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("manage_conflicts_text", "Please manage conflicts to activate pricing!", "pricing_conflict_modal")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("you_have_3_options", "You have 3 options", "pricing_conflict_modal")) + ": ", 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                            _hoisted_8,
                                            (0, vue_2.createElementVNode)("span", null, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_text_1", "Delete conflicting filters and save", "pricing_conflict_modal")) + " ", 1),
                                                (0, vue_2.createElementVNode)("i", _hoisted_9, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_tooltip_text_1", "The pricing will be activated", "pricing_conflict_modal")), 1)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                            _hoisted_12,
                                            (0, vue_2.createElementVNode)("span", null, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_text_2", "Save", "pricing_conflict_modal")) + " ", 1),
                                                (0, vue_2.createElementVNode)("i", _hoisted_13, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_tooltip_text_2", "In this case the pricing will be saved but not activated", "pricing_conflict_modal")), 1)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                            _hoisted_16,
                                            (0, vue_2.createElementVNode)("span", null, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_text_3", "Deactivate conflicts", "pricing_conflict_modal")) + " ", 1),
                                                (0, vue_2.createElementVNode)("i", _hoisted_17, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_conflict_tooltip_text_3", "The current pricing will be activated and the conflicting pricings will be deactivated", "pricing_conflict_modal")), 1)
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.conflictSaveButtonIsActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("conflits_resolved_successfully", "Conflicts resolved successfully!", "pricing_conflict_modal")), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.pricingConflicts)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.groupedConflicts, (conflictGroup) => {
                                    var _a;
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: conflictGroup.id,
                                        class: (0, vue_2.normalizeClass)(["border-1 border-gray odd:bg-gray", __props.expandedConflictRow === conflictGroup.id ? 'border-gray-darker' : ''])
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(conflictGroup.name), 1),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "flex-1 btn btn-danger btn-link md:hidden whitespace-nowrap",
                                                    onClick: ($event) => (deleteConflictedPricingFilters(conflictGroup.id))
                                                }, [
                                                    _hoisted_24,
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete_all", "Delete all", "pricing_conflict_modal")), 1)
                                                ], 8, _hoisted_23)
                                            ]),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "btn btn-primary btn-link !text-gray-darker",
                                                onClick: ($event) => (expandConflictRowToggle(conflictGroup.id))
                                            }, [
                                                (__props.expandedConflictRow === conflictGroup.id)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_26))
                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_27))
                                            ], 8, _hoisted_25)
                                        ]),
                                        (__props.expandedConflictRow === conflictGroup.id)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("brand", "Brand", "pricing_conflict_modal")), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_30, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("diameter", "Diameter", "pricing_conflict_modal")), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)(conflictGroup.type === (0, vue_2.unref)(PricingEnum_1.PricingTypeEnum).PERCENT ?
                                                    "%" :
                                                    (_a = __props.currentUser) === null || _a === void 0 ? void 0 : _a.customer.currencyCode), 1),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "hidden md:flex-1 btn btn-danger btn-link whitespace-nowrap",
                                                    onClick: ($event) => (deleteConflictedPricingFilters(conflictGroup.id))
                                                }, [
                                                    _hoisted_33,
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete_all", "Delete all", "pricing_conflict_modal")), 1)
                                                ], 8, _hoisted_32)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (__props.expandedConflictRow === conflictGroup.id)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_34, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(conflictGroup.conflicts, (conflict, i) => {
                                                    var _a;
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: conflict.customerPricingId,
                                                        class: (0, vue_2.normalizeClass)([i % 2 === 0 ? 'odd:bg-white' : 'even:bg-gray', "flex gap-10 items-center"])
                                                    }, [
                                                        (0, vue_2.createElementVNode)("div", {
                                                            class: (0, vue_2.normalizeClass)(["flex w-full md:border-none", i !== conflictGroup.conflicts.length - 1 ?
                                                                    'border-b-1 border-gray border-gray-darker' : ''])
                                                        }, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_36, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("brand", "Brand", "pricing_conflict_modal")), 1),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_37, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("diameter", "Diameter", "pricing_conflict_modal")), 1),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_38, (0, vue_2.toDisplayString)(conflictGroup.type === (0, vue_2.unref)(PricingEnum_1.PricingTypeEnum).PERCENT ?
                                                                    "%" :
                                                                    (_a = __props.currentUser) === null || _a === void 0 ? void 0 : _a.customer.currencyCode), 1),
                                                                _hoisted_39
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_41, (0, vue_2.toDisplayString)(conflict.conflictingFilter.brand), 1),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_42, (0, vue_2.toDisplayString)(conflict.conflictingFilter.diameter), 1),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_43, (0, vue_2.toDisplayString)(conflict.conflictingFilter.percentPricing !== 0 ?
                                                                    conflict.conflictingFilter.percentPricing :
                                                                    conflict.conflictingFilter.fixedPricing), 1),
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "flex-1 btn btn-danger btn-link",
                                                                    onClick: ($event) => (deleteConflictedPricingFilter(conflict.conflictingFilter.id))
                                                                }, [
                                                                    _hoisted_45,
                                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "delete", "pricing_conflict_modal")), 1)
                                                                ], 8, _hoisted_44)
                                                            ])
                                                        ], 2)
                                                    ], 2));
                                                }), 128))
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ], 2));
                                }), 128))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                            (!__props.conflictSaveButtonIsActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn btn-rounded btn-primary",
                                    onClick: close
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "pricing_conflict_modal")), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            (!__props.conflictSaveButtonIsActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 1,
                                    class: "btn btn-rounded btn-primary",
                                    onClick: saveAndDeactivatePricing
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("deactivate_conflicts", "Deactivate conflicts", "pricing_conflict_modal")), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.conflictSaveButtonIsActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 2,
                                    class: "btn btn-rounded btn-primary btn-success",
                                    onClick: activatePricing
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "pricing_conflict_modal")), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["title", "is-open"]));
        };
    }
});
